export default __webpack_public_path__ + "static/media/No77Closed.2b50f308.jpg";